import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { ICommercialSettings, IUpdateCommercialSettingsRequest } from '../interfaces/commercial.interface';

const headers = () => AuthService.getAuthHeader();

export const CommercialSettingsService = {
    /** R-21: `get()` never writes — a transient defaults DTO comes back even for an institution
     * with no persisted row. */
    get: async (institutionId: string): Promise<ICommercialSettings> =>
        (await axios.get(ENDPOINTS.COMMERCIAL_SETTINGS.GET(institutionId), { headers: headers() })).data,

    upsert: async (institutionId: string, request: IUpdateCommercialSettingsRequest): Promise<ICommercialSettings> =>
        (await axios.put(ENDPOINTS.COMMERCIAL_SETTINGS.UPDATE(institutionId), request, { headers: headers() })).data,
};
